import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import {
  NavSlimLinks,
  VacationFlowInput,
  VacationFlowOutput,
  VacationSearchContent
} from './models/nav-slim-links.interfaces';

@Component({
  selector: 'idp-nav-slim-links',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-slim-links.component.html',
  styleUrls: ['./nav-slim-links.component.scss']
})
export class NavSlimLinksComponent {
  shopContent = input<NavSlimLinks>();
  vacationContent = input<VacationSearchContent>();
  vacationFlowInput = input<VacationFlowInput>({} as VacationFlowInput);

  modifyButtonClicked = output<boolean>();
  vacationFlowOutput = output<VacationFlowOutput>();
  modifyButtonOpen = false;

  content = computed<NavSlimLinks | VacationSearchContent | undefined>(
    () => this.shopContent() ?? this.vacationContent()
  );

  toggleModifyButton(): void {
    this.modifyButtonOpen = !this.modifyButtonOpen;
    this.modifyButtonClicked.emit(this.modifyButtonOpen);
    this.vacationFlowOutput.emit({
      modifyButtonClick: this.modifyButtonOpen,
      startOverButtonClick: false
    });
  }

  scrollToTop(): void {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  get separatorClasses(): string {
    return this.vacationContent()
      ? 'hidden tablet:block mx-[8px] tablet:mx-[18px]'
      : 'hidden laptop:block laptop:mx-[10px]';
  }

  onClick(): void {
    if (this.vacationFlowInput().startOverVacation) {
      this.vacationFlowOutput.emit({
        modifyButtonClick: false,
        startOverButtonClick: true
      });
    } else {
      this.toggleModifyButton();
    }
    this.scrollToTop();
  }
}
